// extracted by mini-css-extract-plugin
export default {"loaderWrapper":"loaderScreen_loaderWrapper__VhH05","description":"loaderScreen_description__FV2Rr"};